import Input, { InputProps } from './Input';

const Password = ({ ...props }: InputProps & { required?: boolean }) => {
  return <Input type="password" {...props} />;
};

export default Password;
